
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrderTiss, PageOptions, ApiGateway } from 'cw-backend';

@Injectable()
export class OrderTissDeclarationListProvider {



    constructor(
        public gw: ApiGateway,
    ) {}


    getById(ordertissId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`order/order-tiss-declaration/${ordertissId}`)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                    },
                    error: (error: HttpResponse<any>) => {
                        reject(error);
                    }
                });
        });
    }
}

